import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from "./en_US.json";
import ptBR from "./pt_BR.json";

const getInitialLanguage = () => {
  if (typeof window === "undefined") {
    return "pt-BR";
  }

  return sessionStorage.getItem("lang") || "pt-BR";
};

i18next.use(initReactI18next).init({
  resources: {
    "pt-BR": {
      translation: ptBR,
    },
    "en-US": {
      translation: enUS,
    },
  },
  lng: getInitialLanguage(),
  fallbackLng: "pt-BR",
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
